import { Col as AntdCol, Row as AntdRow } from "antd";
import { CMP_PREFIX } from "@/base/constant";
import type { GetProps } from "antd";

export type ColProps = Partial<GetProps<typeof AntdCol>>;
export type RowProps = Partial<GetProps<typeof AntdRow>>;

export const gridPrefixCls = `${CMP_PREFIX}-grid`;

export const Col = ({ ...props }: ColProps) => {
  return <AntdCol {...props} />;
};

export const Row = ({ ...props }: RowProps) => {
  return <AntdRow {...props} />;
};
